import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { buttonReset, buttonCommon, translucentDark, transparentGreen, buttonFilled } from "css/buttons"
import { body50, bold, legend100, legend80, legend110, body100, headline30 } from "css/text"
import getMediaQuery, { media } from "css/breakpoints"

const IN_DURATION = 600
const OUT_DURATION = 200
export const KILL_DURATION = 300
export const RESET_DURATION = 300
const IN_EASE = "1,1,1,1" //".32,.94,.6,1"
const OUT_EASE = "1,1,1,1" //".22,1,.36,1"
const KILL_EASE = "1,1,1,1" //".22,1,.36,1"
const RESET_EASE = "1,1,1,1" //".22,1,.36,1"
const SCALE_DURATION = 600
const SCALE_EASE = ".32,.94,.6,1"

export const wv_willfade = css`
  opacity: 0;
  visibility: hidden;
  transition: opacity ${OUT_DURATION}ms cubic-bezier(${OUT_EASE}) 0ms, visibility 0ms linear ${OUT_DURATION}ms;
  will-change: opacity, visibility;
  &.wv_reveal {
    transition: opacity ${IN_DURATION}ms cubic-bezier(${IN_EASE}) 0ms, visibility 0ms 0ms;
    opacity: 1;
    visibility: visible;
  }
  .wv_kill & {
    transition: opacity ${KILL_DURATION}ms cubic-bezier(${KILL_EASE}) 0ms, visibility 0ms linear ${KILL_DURATION}ms;
  }
  .wv_reset & {
    transition: opacity ${RESET_DURATION}ms cubic-bezier(${RESET_EASE}) 0ms, visibility 0ms linear ${RESET_DURATION}ms;
  }
`

export const wv_willtransform = (from, to) => css`
  transition: none;
  will-change: transform;
  transform: ${from};
  &.wv_trans {
    transition: transform ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE}) 0ms;
    transform: ${to};
  }
`

export const Main = styled.div`
  --wv-outer-margin: 5vw;
  --wv-steplist-spacing: 5%;
  --wv-arrow-size: 36px;
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  display: grid;
  //background: linear-gradient(0deg, #f0f0f0, #fff);
  overflow: hidden;
  --wv-cover-scale: 1;
  --wv-cover-translate-X: 0%;
  --wv-cover-translate-Y: 0%;
  --wv-cover-transform-origin: 50% 0%;

  ${getMediaQuery("l")} {
    --wv-outer-margin: 2vw;
    --wv-cover-scale: 1.2;
    --wv-cover-translate-Y: 0%;
  }

  ${getMediaQuery("xxll")} {
    --wv-cover-scale: 1.2;
    --wv-cover-translate-Y: 0%;
  }

  transition: transform ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE}), height ${SCALE_DURATION}ms cubic-bezier(${SCALE_EASE});

  &.wv_reveal {
    &:focus-within {
      nav {
        visibility: visible;
      }
    }
  }
`

/*


  > section:not(.cfgvar-wishlist) {
    height: var(--watch-p-height) !important;
    min-height: 180px !important;
    max-height: 260px;
    margin-top: var(--watch-p-offsetY);
    //    transform: translateY(var(--watch-p-offsetY));
    &:nth-of-type(2) {
      //      --shadow-ratio-r: 1180 / 1380;
      figure {
        width: 100%;
        &:nth-of-type(1) {
//          visibility: hidden;

          .wv_step_0 & {
            visibility: visible;
          }
        }
      }
    }
    img {
      display: block;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  > section.cfgvar-wishlist {
    left: 0;
    padding-inline: var(--wv-outer-margin);
    padding-block: var(--wv-outer-margin);
  }

  > div:last-of-type {
    top: 0;
  }

  */

export const Wrapper = styled.div`
  grid-area: 1/-1;
  position: relative;
  z-index: 0;
  align-self: stretch;
  display: grid;

  .cfgvar-wishlist {
    padding-block: 0;
    padding-inline: 0;
    justify-self: start;

    > div {
      width: calc(10vw + 15px);
      height: calc(2rem + 15px);
      > div {
        display: none;
      }
    }

    button {
      width: 100%;
      height: 100%;
      display: grid;
      box-sizing: border-box;
      align-content: center;
      justify-content: center;

      &.focus-visible {
        outline-offset: -3px !important;
      }
    }
    svg {
      width: 15px;
      height: 15px;
    }

    ${getMediaQuery("m")} {
      > div {
        width: calc(10vw + 15px);
        height: calc(4rem + 15px);
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }
    ${getMediaQuery("l")} {
      > div {
        width: calc(4vw + 15px);
        height: calc(3rem + 15px);
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }

    ${getMediaQuery("xxll")} {
      > div {
        height: calc(4rem + 15px);
      }
    }
  }

  .cfgvar-newmodel {
    position: relative;
    margin-top: calc(-1lh - 16px);
    padding-block: 0;
    padding-inline: var(--gv-padding-inline) 0;
    align-self: stretch;
    ${legend110}

    > div {
      > div {
      }
    }
  
    button {
      display: none;
    }

    ${getMediaQuery("m")} {
      > div {
        > div {
          font-size: .9rem;
          }
      }
    }
  }
`

export const Close = styled.button`
  position: absolute;
  z-index: 1;
  top: 0;
  justify-self: end;
  ${buttonReset}
  cursor: pointer;
  width: calc(10vw + 12px);
  height: calc(2rem + 12px);
  svg {
    width: 12px;
    height: 12px;
  }

  ${wv_willfade}

  span {
    display: none;
  }

  ${getMediaQuery("m")} {
    width: calc(10vw + 12px);
    height: calc(4rem + 12px);
    svg {
      width: 12px;
      height: 12px;
    }
  }

  ${getMediaQuery("l")} {
    width: calc(5vw + 12px);
    height: calc(3rem + 12px);
    svg {
      width: 12px;
      height: 12px;
    }
  }

  ${getMediaQuery("xxll")} {
    height: calc(4rem + 12px);
  }

  &.focus-visible {
    outline-offset: -3px !important;
  }
`

export const Marker = styled.div`
  position: relative;
  height: 30px;
  visibility: hidden;
`

export const SubWrapper = styled.div`
  position: relative;
  ${wv_willfade}
  min-height: 1.5rem;
  max-height: 1.5rem;
  overflow: hidden;
  transition: opacity ${OUT_DURATION}ms cubic-bezier(${OUT_EASE}) 0ms, visibility 0ms linear ${OUT_DURATION}ms, max-height 300ms cubic-bezier(0.33,1,0.68,1) 100ms;
  will-change: opacity, visibility, height;
  &.wv_reveal {
    max-height: 12rem;
    transition: opacity ${IN_DURATION}ms cubic-bezier(${IN_EASE}) 0ms, visibility 0ms 0ms, max-height 300ms cubic-bezier(0.33,1,0.68,1) 100ms;
  }

  > section {
    padding-bottom: 0 !important;
  }

  > nav {
    button {
      padding-bottom: 0 !important;
    }
  }

  ${getMediaQuery("l")} {
    max-height: unset;
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  position: relaitve;
  z-index: 1;
  column-gap: .5rem;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;

  &::before {
    content: "";
    width: 20px;
    transform: translateX(-100%);
    [dir="rtl"] & {
      transform: translateX(100%);
    }
  }

  > svg {
    ${wv_willfade}
    &.wv_reveal {
      transition-delay: 600ms;
    }
    fill: var(--light-black);
  }
  
  button {
    transform: scale(.8);
    ${buttonFilled}
    position: relative;

    ${wv_willfade}

    &.wv_apply {
      ${transparentGreen}
    }

    &.wv_reset {
      &::after {
        content: "↺";
        font-size: 1.5rem;
        font-weight: 100;
      }
    }
  }
`

export const ApplyToAllCTAWrapper = styled.div`
  position: relative;
  padding: 0 var(--wv-outer-margin) 10px;
  display: flex;
  justify-content: end;

  ${wv_willfade}
  &.wv_reveal {
    transition-delay: 300ms;
  }

  button {
    ${buttonReset}
    ${legend80}
    ${bold}
    padding: 10px 0;
  }
`

export const ApplyButton = styled.button`
  position: absolute;
  z-index: 5;
  top: 1rem;
  margin-inline-end: 1rem;
  justify-self: end;
  ${buttonFilled}
  ${transparentGreen}
  font-size: .75rem;
  padding: .25rem 1rem;
  height: auto;
  display: none;

  .wv_applytoall & {
    display: flex;
  }
  
  .gv-selected & {
    visibility: hidden;
  }
`